var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 86,
    viewBox: "0 0 92 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64029 37.4532C5.64029 37.4532 46.3298 18.5745 60.4416 11.9269C65.8512 9.26801 84.1967 0.759178 84.1967 0.759178C84.1967 0.759178 92.664 -2.96323 91.9582 6.07714C91.723 9.79979 89.8414 22.8287 87.96 36.9214C85.1375 56.8638 82.0799 78.6674 82.0799 78.6674C82.0799 78.6674 81.6096 84.7833 77.6112 85.8468C73.6128 86.9104 67.0271 82.1244 65.8512 81.0604C64.9102 80.263 48.2113 68.2974 42.0961 62.4477C40.4496 60.8523 38.5682 57.6617 42.3312 53.9391C50.7985 45.1643 60.9118 34.2625 67.0271 27.3492C69.8496 24.1584 72.6718 16.7131 60.9118 25.7537C44.213 38.7828 27.7491 51.0141 27.7491 51.0141C27.7491 51.0141 23.9857 53.6729 16.9299 51.2797C9.87372 48.887 1.64167 45.6961 1.64167 45.6961C1.64167 45.6961 -4.00261 41.7076 5.64029 37.4532Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.3c325eb8b1d964d8d7015f14c9dfb945.svg";
export { ForwardRef as ReactComponent };